// extracted by mini-css-extract-plugin
export default {"error_message":"index-module--error_message--0NL2n"};